import { render, staticRenderFns } from "./LockAccountButton.vue?vue&type=template&id=4d03abb8&"
import script from "./LockAccountButton.vue?vue&type=script&lang=js&"
export * from "./LockAccountButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d03abb8')) {
      api.createRecord('4d03abb8', component.options)
    } else {
      api.reload('4d03abb8', component.options)
    }
    module.hot.accept("./LockAccountButton.vue?vue&type=template&id=4d03abb8&", function () {
      api.rerender('4d03abb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/Account/LockAccountButton.vue"
export default component.exports